import ActionTypes from 'app/error/ActionTypes';
import reducer from 'app/error/reducer';

export default {
  reducers: {
    errors: reducer,
  },
  actionTypes: ActionTypes,
};
